import { render } from "./BakaPerubahanShow.vue?vue&type=template&id=5961dbe7"
import script from "./BakaPerubahanShow.vue?vue&type=script&lang=js"
export * from "./BakaPerubahanShow.vue?vue&type=script&lang=js"

import "./BakaPerubahanShow.vue?vue&type=style&index=0&id=5961dbe7&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__